import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Drive-thru menu totem, ~2.4 m: two dark posts carrying a big dark menu
// panel with lighter menu-card rectangles proud of the face and a muted red
// header band. Faces +Z.
const BLACK = "#2e2e30";
const PANEL = "#3f4044";
const CARD = "#c9c6be";
const RED = "#b04a3a";

export const driveThruSign = defineModel({
  id: "drive-thru-sign",
  batchId: "modern",
  name: "Drive-thru sign",
  tags: ["modern", "outdoor", "street", "sign", "restaurant", "drive-thru"],
  summary: "A drive-thru menu totem with lit menu cards.",
  description:
    "A drive-thru menu totem of the Modern Living kit: two dark posts " +
    "carrying a 1.0 x 1.2 m menu panel with three lighter menu-card " +
    "rectangles proud of the face and a muted red header band. About 2.4 m " +
    "high, facing +Z — place it beside the lane.",
  tiles: { w: 1, h: 1 },
  footprint: 1.5,
  parts(): Part[] {
    return [
      // Posts.
      {
        geometry: new THREE.BoxGeometry(0.09, 1.2, 0.09),
        color: BLACK,
        position: [-0.34, 0.6, 0],
      },
      {
        geometry: new THREE.BoxGeometry(0.09, 1.2, 0.09),
        color: BLACK,
        position: [0.34, 0.6, 0],
      },
      // Menu panel, 1.0 wide x 1.2 high.
      {
        geometry: new THREE.BoxGeometry(1.0, 1.2, 0.08),
        color: PANEL,
        position: [0, 1.7, 0],
      },
      // Red header band across the top, proud of the face.
      {
        geometry: new THREE.BoxGeometry(1.0, 0.2, 0.04),
        color: RED,
        position: [0, 2.16, 0.04],
      },
      // Three menu cards proud of the face.
      {
        geometry: new THREE.BoxGeometry(0.28, 0.78, 0.03),
        color: CARD,
        position: [-0.33, 1.56, 0.05],
      },
      {
        geometry: new THREE.BoxGeometry(0.28, 0.78, 0.03),
        color: CARD,
        position: [0, 1.56, 0.05],
      },
      {
        geometry: new THREE.BoxGeometry(0.28, 0.78, 0.03),
        color: CARD,
        position: [0.33, 1.56, 0.05],
      },
    ];
  },
  animations: [],
});
